/**
 * Database Id metadata name.
 */
export const metadataDatabaseId = "databaseId";
/**
 * Index of cell with metadata of whole row.
 */
export const metadataCellIndex = 0;
/**
 * Action generated by excel function.
 */
export const functionChangeSource = "function";
/**
 * Default action from Handsontable.
 */
export const loadDataChangeSource = "loadData";


// WEBPACK FOOTER //
// ./App/components/Handsontable/constants.js